export default __webpack_public_path__ + "static/media/vijaywadaDeitieFive.b63189c4.png";